(() => {
  if (window.frHeaderSearchInitialized) return;
  window.frHeaderSearchInitialized = true;

  const widgetSelector = '#cm_SearchBox, #cm_SearchBoxDialog, #cm_SearchBoxDialogButton';
  const actionLabels = document.querySelector('script[data-fr-predictive-labels]')?.dataset || {};
  let scheduled = false;
  let wasOpen = false;
  let returnFocus;
  let fallbackDraft;
  let pendingSearch;

  function cancelPendingSearch() {
    pendingSearch?.observer.disconnect();
    pendingSearch = null;
  }

  function finishSearch() {
    if (!pendingSearch) return;
    const { modal, response, requestQuery, query } = pendingSearch;
    if (!modal.isConnected || !modal.isOpen()) {
      cancelPendingSearch();
      return;
    }
    const currentResponse = window.Convermax?.getSearchResponse?.();
    const currentRequest = window.Convermax?.getSearchRequest?.();
    const received = currentResponse && currentResponse !== response;
    const alreadyVisible = currentResponse === response && currentRequest?.query === requestQuery && query === response?.query;
    if (!(received || alreadyVisible) || currentResponse.query !== currentRequest?.query) return;
    if (document.querySelector('#cm_results .cm_loading, #cm-collection-page .cm_loading')) return;
    cancelPendingSearch();
    modal.close();
  }

  function beginSearch(target) {
    const scope = target.closest?.('#cm_SearchBox');
    const modal = scope?.closest('details-modal.header__search');
    const results = document.querySelector('#cm_results, #cm-collection-page');
    if (!modal?.isOpen() || !results || !window.Convermax?.getSearchResponse || !window.Convermax?.getSearchRequest) return;
    cancelPendingSearch();
    const observer = new MutationObserver(() => requestAnimationFrame(finishSearch));
    pendingSearch = {
      modal,
      observer,
      response: window.Convermax.getSearchResponse(),
      requestQuery: window.Convermax.getSearchRequest()?.query,
      query: scope.querySelector('.cm_searchInput')?.value,
    };
    observer.observe(results, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    requestAnimationFrame(finishSearch);
  }

  function syncMountedSearch() {
    const modal = document.querySelector('details-modal.header__search:has(details[open])');
    const app = document.getElementById('cm_SearchBox');
    const input = app?.querySelector('input.cm_searchInput');
    if (!modal || !input) return;
    const nativeInput = modal.querySelector('input[name="q"]');
    const draft = nativeInput ? {
      modal, value: nativeInput.value, focused: document.activeElement === nativeInput,
      start: nativeInput.selectionStart, end: nativeInput.selectionEnd,
    } : fallbackDraft?.modal === modal ? fallbackDraft : null;
    const content = modal.querySelector('.search-modal__content');
    if (content && !content.contains(app)) {
      const nativeForm = content.querySelector(':scope > .search-modal__form');
      if (nativeForm) nativeForm.replaceWith(app);
      else content.prepend(app);
    }
    if (!draft) return;
    fallbackDraft = null;
    input.value = draft.value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    if (draft.focused && (document.activeElement === document.body || !document.activeElement?.isConnected)) {
      trapFocus(content, input);
      input.setSelectionRange(draft.start, draft.end);
    }
  }

  function makeButton(element, label) {
    if (!element) return;
    if (!element.matches('button, a[href]')) {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.setAttribute('data-fr-search-button', '');
    }
    element.setAttribute('aria-label', label);
  }

  function syncSuggestionSections() {
    document.querySelectorAll('#cm_SearchBox .cm_autocomplete, #cm_SearchBoxDialog .cm_autocomplete').forEach((panel) => {
      panel.querySelectorAll('[data-fr-search-action]').forEach((label) => label.remove());
      const labels = [
        ['.Suggestions', actionLabels.headingSuggestions],
        ['.Trending', actionLabels.headingTrending],
        ['.Product.type', actionLabels.headingProductTypes],
        ['.Products', actionLabels.headingProducts],
        ['.Articles', actionLabels.headingArticles],
      ];
      panel.querySelectorAll('.section').forEach((section) => {
        const label = labels.find(([selector, text]) => text && section.matches(selector))?.[1];
        const heading = section.querySelector('.section-title-div .section-title > b');
        if (label && heading && heading.textContent !== label) heading.textContent = label;
      });
    });
  }

  function sync() {
    scheduled = false;
    syncMountedSearch();
    syncSuggestionSections();
    const trigger = document.querySelector('#cm_SearchBoxDialogButton .cm_searchBoxDialogButton');
    const dialog = document.getElementById('cm_SearchBoxDialog');
    const open = !!dialog?.querySelector('.cm_search-box-root__dialog');

    makeButton(trigger, 'Search');
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'cm_SearchBoxDialog');
      trigger.setAttribute('aria-expanded', String(open));
    }
    if (dialog) {
      dialog.setAttribute('aria-hidden', String(!open));
      if (open) {
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        dialog.setAttribute('aria-label', 'Search');
      } else {
        dialog.removeAttribute('role');
        dialog.removeAttribute('aria-modal');
      }
      makeButton(dialog.querySelector('.cm_search-box-dialog_close-button'), 'Close search');
    }
    document.querySelectorAll('#cm_SearchBox .cm_searchInput, #cm_SearchBoxDialog .cm_searchInput').forEach((input) => {
      input.setAttribute('aria-label', 'Search by part, brand or SKU');
      input.setAttribute('placeholder', 'Search by part, brand or SKU');
      input.setAttribute('enterkeyhint', 'search');
    });
    document.querySelectorAll('#cm_SearchBox .cm_search-box_clear, #cm_SearchBoxDialog .cm_search-box_clear')
      .forEach((element) => makeButton(element, 'Clear search'));

    if (wasOpen && !open) {
      const active = document.activeElement;
      if (!active || active === document.body || !active.isConnected || dialog?.contains(active)) {
        const target = returnFocus?.isConnected ? returnFocus : trigger;
        target?.focus({ preventScroll: true });
      }
    }
    wasOpen = open;
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function initializeGarage() {
    const garage = document.getElementById('cm-garage');
    if (!garage) return;

    function activateGarageControl(control) {
      if (control.matches('.garage-button')) {
        // Convermax's dropdown toggle listens to pointerdown, not click.
        const Pointer = window.PointerEvent || MouseEvent;
        control.dispatchEvent(new Pointer('pointerdown', { bubbles: true, cancelable: true, button: 0, pointerType: 'mouse' }));
      } else control.click();
    }

    function syncGarage() {
      garage.querySelectorAll('.garage-button, .cm_addButton, [data-cm-role="select-vehicle"], [data-cm-role="remove-vehicle"], [data-cm-role="clear-garage"]').forEach((control) => {
        if (!control.matches('button, a[href]')) {
          control.setAttribute('role', 'button');
          control.setAttribute('tabindex', '0');
          control.setAttribute('data-fr-garage-button', '');
        }
        if (control.matches('[data-cm-role="remove-vehicle"]')) {
          const vehicle = control.closest('.garage-item')?.querySelector('[data-cm-role="select-vehicle"]')?.textContent.trim();
          control.setAttribute('aria-label', vehicle ? `Remove ${vehicle} from garage` : 'Remove vehicle from garage');
        }
      });
      const trigger = garage.querySelector('.garage-button');
      const dropdown = garage.querySelector('.cm_garageDropdown');
      if (trigger) {
        trigger.setAttribute('aria-label', trigger.title || 'Garage');
        trigger.setAttribute('aria-expanded', String(!!dropdown && !dropdown.classList.contains('cm_hide')));
      }
    }

    syncGarage();
    // Provider renders and class changes stay inside this small header widget.
    // Our role/label attributes cannot retrigger this observer.
    new MutationObserver(syncGarage).observe(garage, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'title'],
    });
    garage.addEventListener('keydown', (event) => {
      if (event.isComposing) return;
      const dropdown = garage.querySelector('.cm_garageDropdown');
      if (event.key === 'Escape' && dropdown && !dropdown.classList.contains('cm_hide')) {
        event.preventDefault();
        const trigger = garage.querySelector('.garage-button');
        // Restore focus before Convermax's existing Escape handler closes the
        // dropdown; moving focus afterward would reopen it through focusout.
        trigger?.focus({ preventScroll: true });
        return;
      }
      const control = event.target.closest?.('[data-fr-garage-button]');
      if (!control || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      if (!event.repeat) activateGarageControl(control);
    }, true);
  }

  function initialize() {
    sync();
    initializeGarage();
    document.addEventListener('input', (event) => {
      if (event.target.matches?.('#cm_SearchBox input')) cancelPendingSearch();
      const modal = event.target.closest?.('details-modal.header__search');
      if (!modal || !event.target.matches('input[name="q"]')) return;
      fallbackDraft = {
        modal, value: event.target.value, focused: document.activeElement === event.target,
        start: event.target.selectionStart, end: event.target.selectionEnd,
      };
    }, true);
    document.addEventListener('toggle', (event) => {
      if (event.target.open) return;
      if (event.target === pendingSearch?.modal.querySelector('details')) cancelPendingSearch();
      if (event.target === fallbackDraft?.modal.querySelector('details')) fallbackDraft = null;
    }, true);
    document.addEventListener('cm_set_query', (event) => beginSearch(event.target), true);
    // The app mounts and replaces these controls after the theme has loaded.
    // Observe child changes only; our accessibility attributes cannot retrigger it.
    new MutationObserver((records) => {
      if (records.some(({ target, addedNodes }) =>
        target instanceof Element && target.closest(widgetSelector) ||
        [...addedNodes].some((node) => node instanceof Element && (node.matches(widgetSelector) || node.querySelector(widgetSelector)))
      )) scheduleSync();
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', (event) => {
      if (event.target.closest?.('#cm_SearchBox [data-cm-role="add-query"], #cm_SearchBox .cm_autocomplete .nav-item')) beginSearch(event.target);
      const trigger = event.target.closest?.('#cm_SearchBoxDialogButton .cm_searchBoxDialogButton');
      if (trigger) returnFocus = trigger;
      const clear = event.target.closest?.('.cm_search-box_clear');
      const scope = clear?.closest('#cm_SearchBox, #cm_SearchBoxDialog');
      if (scope) requestAnimationFrame(() => {
        if (!scope.isConnected) return;
        const nativeModal = scope.closest('details-modal');
        if (nativeModal && !nativeModal.querySelector('details')?.open) return;
        if (scope.id === 'cm_SearchBoxDialog' && !scope.querySelector('.cm_search-box-root__dialog')) return;
        const active = document.activeElement;
        if (active === document.body || scope.contains(active)) {
          scope.querySelector('.cm_searchInput')?.focus({ preventScroll: true });
        }
      });
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.isComposing) return;
      if (event.key === 'Enter' && event.target.matches?.('#cm_SearchBox .cm_searchInput, #cm_SearchBox .cm_autocomplete .nav-item')) beginSearch(event.target);
      const dialog = document.getElementById('cm_SearchBoxDialog');
      if (event.key === 'Escape' && dialog?.contains(event.target)) {
        const close = dialog.querySelector('.cm_search-box-dialog_close-button');
        if (close) {
          event.preventDefault();
          event.stopPropagation();
          close.click();
        }
        return;
      }
      const control = event.target.closest?.('[data-fr-search-button]');
      if (!control || !control.closest(widgetSelector) || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      if (!event.repeat) control.click();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
